import gql from 'graphql-tag';

export const integrationDesktopFragment = gql`
  fragment integrationDesktopFragment on IntegrationDesktop {
    dokkioClass
    id
    accountID
    syncFolderPath
  }
`;
export default integrationDesktopFragment;
